// extracted by mini-css-extract-plugin
module.exports = {"sectionFooter":"styles_sectionFooter__2Jizl"};